import { Box, Button, Divider, Grid, Link, Switch, TextField, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useStyles } from './style'
import { TenantEditSlice } from '../../../reducers'
import { useEvent, useEventsOnViewLoad } from '@emerald-works/react-event-bus-client'
import { useTenantFormContext } from '../tenant-form-context'
import { useSelector } from 'react-redux'
import CopyToClipboard from 'react-copy-to-clipboard'
import { CopyIcon } from '../../../components/icons'
import { BannerStatic } from '../../../components'
import { useConfirm } from 'material-ui-confirm'

const FAKE_API_KEY_PLACEHOLDER = Array.from({ length: 32 }).fill('*').join('')
const SWAGGER_URL = `${process.env.REACT_APP_API_GATEWAY_HTTP_ADDRESS}/api/integration/swagger`

export const IntegrationSettings = () => {
  const classes = useStyles()
  const { spacing } = useTheme()
  const { tenant } = useTenantFormContext()
  const confirm = useConfirm()

  const [getTenantApiIntegrationKeys, generateTenantApiKeys, removeTenantApiKeys] = useEvent([
    TenantEditSlice.eventBus.getTenantApiIntegrationKeys,
    TenantEditSlice.eventBus.generateTenantApiKeys,
    TenantEditSlice.eventBus.removeTenantApiKeys
  ])

  const apiIntegration = useSelector(TenantEditSlice.selectors.apiIntegration)

  useEventsOnViewLoad(() => {
    if (tenant.pk && !getTenantApiIntegrationKeys.hasBeenTriggered) {
      getTenantApiIntegrationKeys.trigger({
        tenantId: tenant.pk
      })
    }
  }, [tenant?.pk])

  const handleToggleIntegration = () => {
    if (apiIntegration) {
      confirm({
        title: 'Deactivate API Integration',
        description: 'Are you sure you want to deactivate the API Integration? New keys will be generated if you activate it later.',
        confirmationText: 'Yes, deactivate it.',
        cancellationText: 'No, Thanks.',
        titleProps: {
          'data-test': 'remove-api-integration-confirmation-title'
        },
        confirmationButtonProps: {
          'data-test': 'confirm-remove-api-integration-button'
        },
        cancellationButtonProps: {
          'data-test': 'cancel-remove-api-integration-button'
        }
      }).then(() => {
        removeTenantApiKeys.trigger({
          tenantId: tenant.pk
        })
      }).catch(() => {})
    } else {
      generateTenantApiKeys.trigger({
        tenantId: tenant.pk
      })
    }
  }

  const isLoading = getTenantApiIntegrationKeys.isWorking || generateTenantApiKeys.isWorking || removeTenantApiKeys.isWorking

  return (
    <Grid container className={classes.featContainer}>
      <Grid item xs={12}>
        <Box
          border={1}
          borderRadius='undefinedpx'
          borderColor='#E0E0E0'
          display='flex'
          style={{
            justifyContent: 'space-between',
            flexDirection: 'column',
            padding: spacing(1, 4)
          }}
        >
          <Box display='flex' flexDirection='row'>
            <Typography variant='body2' style={{ marginTop: spacing(3.5) }}>
              API Integration
            </Typography>
            <Box
              display='flex'
              style={{
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
                flex: 1,
                padding: spacing(1)
              }}
            >
              <Box style={{ padding: spacing(2, 0.5) }}>
                <Switch
                  color='primary'
                  data-test='api-integration-feature-toggle'
                  checked={!!apiIntegration}
                  onChange={handleToggleIntegration}
                  disabled={isLoading}
                />
              </Box>
            </Box>
          </Box>

          {apiIntegration && (
            <>
              <Divider style={{ marginBottom: spacing(1) }} />

              <Box display='flex' flexDirection='row' gap={2} alignItems='center' justifyContent='space-between' mt={2} mb={2}>
                <TextField
                  label='Public Key'
                  disabled
                  sx={{ flex: 1 }}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <CopyToClipboard
                        text={apiIntegration.publicKey}
                        onCopy={() => {
                          BannerStatic.show({ label: 'Public key copied to clipboard!' })
                        }}
                      >
                        <Button
                          classes={{ root: classes.btnCopy }}
                          color='primary'
                          data-test='copy-public-key-button'
                          startIcon={<CopyIcon />}
                        > Copy
                        </Button>
                      </CopyToClipboard>
                    )
                  }}
                  value={FAKE_API_KEY_PLACEHOLDER}
                />
                <TextField
                  label='Private Key'
                  disabled
                  sx={{ flex: 1 }}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <CopyToClipboard
                        text={apiIntegration.privateKey}
                        onCopy={() => {
                          BannerStatic.show({ label: 'Private key copied to clipboard!' })
                        }}
                      >
                        <Button
                          classes={{ root: classes.btnCopy }}
                          color='primary'
                          data-test='copy-private-key-button'
                          startIcon={<CopyIcon />}
                        > Copy
                        </Button>
                      </CopyToClipboard>
                    )
                  }}
                  value={FAKE_API_KEY_PLACEHOLDER}
                />
              </Box>

              <Divider style={{ marginBottom: spacing(1) }} />

              <Link href={SWAGGER_URL} sx={{ my: 1 }} target='_blank'>API Documentation</Link>
            </>
          )}

        </Box>

      </Grid>

    </Grid>
  )
}
